var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _vm.loading
        ? _c("div", { staticClass: "text-center" }, [
            _vm._v("\n      Loading...\n    ")
          ])
        : _c("div", [
            _c("h2", { staticClass: "mb-2" }, [_vm._v("Gegevens wijzigen")]),
            _vm._v(" "),
            _c(
              "form",
              { on: { submit: _vm.handleSubmit } },
              [
                _vm.error
                  ? _c(
                      "div",
                      {
                        staticClass: "alert alert-danger",
                        attrs: { role: "alert" }
                      },
                      [
                        _vm._v(
                          "\n          Helaas is er wat verkeerds gegaan, controleer en probeer opnieuw.\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.success
                  ? _c(
                      "div",
                      {
                        staticClass: "alert alert-success",
                        attrs: { role: "alert" }
                      },
                      [
                        _vm._v(
                          "\n          Gegevens zijn bijgewerkt.\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-6" },
                    [
                      _c("input-field", {
                        attrs: {
                          error: _vm.first_name.error,
                          type: "text",
                          label: "Voornaam",
                          name: "first_name"
                        },
                        model: {
                          value: _vm.first_name.value,
                          callback: function($$v) {
                            _vm.$set(_vm.first_name, "value", $$v)
                          },
                          expression: "first_name.value"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-6" },
                    [
                      _c("input-field", {
                        attrs: {
                          error: _vm.last_name.error,
                          type: "text",
                          label: "Achternaam",
                          name: "last_name"
                        },
                        model: {
                          value: _vm.last_name.value,
                          callback: function($$v) {
                            _vm.$set(_vm.last_name, "value", $$v)
                          },
                          expression: "last_name.value"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("input-field", {
                  attrs: {
                    error: _vm.email.error,
                    type: "text",
                    label: "Email",
                    name: "email"
                  },
                  model: {
                    value: _vm.email.value,
                    callback: function($$v) {
                      _vm.$set(_vm.email, "value", $$v)
                    },
                    expression: "email.value"
                  }
                }),
                _vm._v(" "),
                _c("input-field", {
                  attrs: {
                    error: _vm.telefoonnummer.error,
                    type: "text",
                    label: "Telefoonnummer",
                    name: "telefoonnummer"
                  },
                  model: {
                    value: _vm.telefoonnummer.value,
                    callback: function($$v) {
                      _vm.$set(_vm.telefoonnummer, "value", $$v)
                    },
                    expression: "telefoonnummer.value"
                  }
                }),
                _vm._v(" "),
                _c("input-field", {
                  attrs: {
                    error: _vm.bedrijfsnaam.error,
                    type: "text",
                    label: "Bedrijfsnaam",
                    name: "bedrijfsnaam"
                  },
                  model: {
                    value: _vm.bedrijfsnaam.value,
                    callback: function($$v) {
                      _vm.$set(_vm.bedrijfsnaam, "value", $$v)
                    },
                    expression: "bedrijfsnaam.value"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-6" },
                    [
                      _c("input-field", {
                        attrs: {
                          error: _vm.kvk.error,
                          type: "text",
                          label: "KVK Nummer",
                          name: "kvk"
                        },
                        model: {
                          value: _vm.kvk.value,
                          callback: function($$v) {
                            _vm.$set(_vm.kvk, "value", $$v)
                          },
                          expression: "kvk.value"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-6" },
                    [
                      _c("input-field", {
                        attrs: {
                          error: _vm.btw.error,
                          type: "text",
                          label: "BTW identificatienummer",
                          name: "btw"
                        },
                        model: {
                          value: _vm.btw.value,
                          callback: function($$v) {
                            _vm.$set(_vm.btw, "value", $$v)
                          },
                          expression: "btw.value"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("input-field", {
                  attrs: {
                    error: _vm.iban.error,
                    type: "text",
                    label: "IBAN nummer",
                    name: "iban"
                  },
                  model: {
                    value: _vm.iban.value,
                    callback: function($$v) {
                      _vm.$set(_vm.iban, "value", $$v)
                    },
                    expression: "iban.value"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-4" },
                    [
                      _c("input-field", {
                        attrs: {
                          error: _vm.adres.error,
                          type: "text",
                          label: "Adres",
                          name: "adres"
                        },
                        model: {
                          value: _vm.adres.value,
                          callback: function($$v) {
                            _vm.$set(_vm.adres, "value", $$v)
                          },
                          expression: "adres.value"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-4" },
                    [
                      _c("input-field", {
                        attrs: {
                          error: _vm.postcode.error,
                          type: "text",
                          label: "Postcode",
                          name: "Postcode"
                        },
                        model: {
                          value: _vm.postcode.value,
                          callback: function($$v) {
                            _vm.$set(_vm.postcode, "value", $$v)
                          },
                          expression: "postcode.value"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-4" },
                    [
                      _c("input-field", {
                        attrs: {
                          error: _vm.plaats.error,
                          type: "text",
                          label: "Plaats",
                          name: "Plaats"
                        },
                        model: {
                          value: _vm.plaats.value,
                          callback: function($$v) {
                            _vm.$set(_vm.plaats, "value", $$v)
                          },
                          expression: "plaats.value"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-lg",
                    attrs: { type: "submit" }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "15",
                          height: "15",
                          viewBox: "0 0 15 15",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M1.95833 14.625H13.0417C13.4616 14.625 13.8643 14.4582 14.1613 14.1613C14.4582 13.8643 14.625 13.4616 14.625 13.0417V4.33333L10.6667 0.375H1.95833C1.53841 0.375 1.13568 0.541815 0.838748 0.838748C0.541815 1.13568 0.375 1.53841 0.375 1.95833V13.0417C0.375 13.4616 0.541815 13.8643 0.838748 14.1613C1.13568 14.4582 1.53841 14.625 1.95833 14.625ZM3.54167 1.95833H6.70833V3.54167H8.29167V1.95833H9.875V5.125H3.54167V1.95833ZM3.54167 8.29167H11.4583V13.0417H3.54167V8.29167Z"
                          }
                        })
                      ]
                    ),
                    _vm._v("\n          Opslaan\n        ")
                  ]
                )
              ],
              1
            )
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/MijnAccount/GegevensWijzigen.vue?vue&type=template&id=2f31deef&
// module id = 430
// module chunks = 0